<div class="p-modal-head01">
  <h1 id="modalTitle" class="p-modal-head01__title" [innerHTML]="'label.AnaMileageClub' | staticMsg"></h1>
  <button id="p-password-input-header-button" class="p-modal-head01__close js-modal-close" (click)="clickClose()">
    <span class="u-visually-hidden" [innerHTML]="'alt.closeModal' | staticMsg"></span>
  </button>
</div>
